import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getApiUrl } from '../../lib/runtimeConfig';
import {
  VStack,
  Text,
  Heading,
  Spinner,
  Button,
  Circle,
} from '@chakra-ui/react';

export function SubscriptionCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const verifySubscription = async () => {
      const sessionId = searchParams.get('session_id');

      if (!sessionId) {
        setStatus('success');
        setTimeout(() => navigate('/app'), 2000);
        return;
      }

      try {
        const response = await fetch(`${getApiUrl()}/api/subscription/verify`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ sessionId }),
        });

        if (!response.ok) {
          throw new Error('Failed to verify subscription');
        }

        setStatus('success');
        setTimeout(() => navigate('/app'), 2000);
      } catch (err) {
        console.error('Subscription verification error:', err);
        setStatus('error');
        setError(err instanceof Error ? err.message : 'Failed to verify subscription');
      }
    };

    verifySubscription();
  }, [searchParams, navigate]);

  return (
    <VStack flex={1} justify="center" align="center" p={6} spacing={6} bg="white">
      {status === 'loading' && (
        <>
          <Spinner size="xl" color="brand.500" />
          <Text fontSize="lg" color="gray.500">
            Verifying your subscription...
          </Text>
        </>
      )}

      {status === 'success' && (
        <>
          <Circle size="80px" bg="green.50">
            <Text fontSize="2xl">✓</Text>
          </Circle>
          <Heading size="lg" textAlign="center">
            You're all set!
          </Heading>
          <Text fontSize="md" color="gray.500" textAlign="center">
            Your subscription is active. Redirecting to dashboard...
          </Text>
        </>
      )}

      {status === 'error' && (
        <>
          <Circle size="80px" bg="red.50">
            <Text fontSize="2xl">✕</Text>
          </Circle>
          <Heading size="lg" textAlign="center">
            Something went wrong
          </Heading>
          <Text fontSize="md" color="red.500" textAlign="center">
            {error}
          </Text>
          <Button
            size="md"
            colorScheme="blue"
            onClick={() => navigate('/onboarding/wizard')}
          >
            Try Again
          </Button>
        </>
      )}
    </VStack>
  );
}

export default SubscriptionCallbackPage;
